import { NextToJump } from './NextToJump';

export default NextToJump;
